export default __webpack_public_path__ + "static/sc-logo-9892cf633aa04d296e57856e74273e62.svg";